export default __webpack_public_path__ + "static/media/wPants_1_p3.550461c8.jpeg";